import Vue from "vue";

export default {
  getOvertimes({ state, commit }) {
    const params = {
      page: state.pageOvertimes,
      per_page: state.perPageOvertimes,
      start_date: state.overtimeDate[0],
      end_date: state.overtimeDate[1],
      ...(state.overtimeSearch && { search_query: state.overtimeSearch }),
      ...(state.overtimeFilter && { status: state.overtimeFilter }),
    };
    commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtimes`, {
          params,
        })
        .then(response => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          commit("OVERTIME_MUTATIONS", {
            key: "overtimes",
            value: response.data.results,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "totalOvertimes",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          reject(error);
        });
    });
  },
  handleSizeChangeOvertimes({ commit, dispatch }, perPage) {
    commit("OVERTIME_MUTATIONS", {
      key: "perPageOvertimes",
      value: perPage,
    });
    commit("OVERTIME_MUTATIONS", { key: "pageOvertimes", value: 1 });
    dispatch("getOvertimes");
  },

  handleCurrentChangeOvertimes({ commit, dispatch }, page) {
    commit("OVERTIME_MUTATIONS", { key: "pageOvertimes", value: page });
    dispatch("getOvertimes");
  },
  approveOvertime({ commit }, payload) {
    commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/overtimes/approve`, payload)
        .then(response => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          reject(error);
        });
    });
  },
  rejectOvertime({ commit }, payload) {
    commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/overtimes/reject`, payload)
        .then(response => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          reject(error);
        });
    });
  },
};
